import { forwardRef } from "react";

import { Circle, type CircleBadgeProps, type CircleProps } from "@eisox/design-system";
import { GatewayIcon } from "@eisox/icons";

interface GatewayProps extends CircleProps {
  uid?: number;
  error?: CircleBadgeProps["variant"];
}

const Gateway = forwardRef<HTMLDivElement, GatewayProps>(
  ({ size = 20, backgroundColor = "darkBlue", color = "white", uid, error, ...props }, ref) => (
    <Circle.Root {...props} ref={ref} size={size} backgroundColor={backgroundColor} color={color}>
      {uid ?? <GatewayIcon />}
      {error && <Circle.Badge variant={error} />}
    </Circle.Root>
  ),
);

Gateway.displayName = "Gateway";

export { Gateway };
export type { GatewayProps };
